import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpCTACenterAligned } from './variants/cp-cta-center-aligned';
import { CpCTALeftAligned } from './variants/cp-cta-left-aligned';
import { CpCTAStretched } from './variants/cp-cta-stretched';
import { CpCTAStretchedWithBackground } from './variants/cp-cta-stretched-with-background';
import { CpCTATitleAndContentSection } from './variants/cp-cta-title-and-content-section';
import { CpCtaSectionRendererWidgetData } from './variants/types';

export const CpCTAWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(
    () => data as CpCtaSectionRendererWidgetData,
    [data],
  );

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.CTALeftAligned:
    case undefined:
      return (
        <CpCTALeftAligned
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.CTACenterAligned:
      return (
        <CpCTACenterAligned
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.CTAStretched:
      return (
        <CpCTAStretched
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.CTAStretchedWithBackground:
      return (
        <CpCTAStretchedWithBackground
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.CTATitleAndContentSection:
      return (
        <CpCTATitleAndContentSection
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    default:
      return <></>;
  }
};
